import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import PT from './locales/pt/pt.json';
import EN from './locales/en/en.json';
import ES from './locales/es/es.json';

export const resources = {
	pt: { translation: PT },
	en: { translation: EN },
	es: { translation: ES }
};

const defaultLanguage = 'en';

const language = navigator.language.split('-')[0] as keyof typeof resources;

i18n.use(initReactI18next).init({
	resources,
	lng: resources[language] ? language : defaultLanguage,
	interpolation: {
		escapeValue: false
	}
});

export default i18n;
